$(function () {

    $('#Reservations .cancel .openBtn').click(function (){
        $(this).parents('.cancel').children('.alert-modal').addClass('active')
    })
    $('#Reservations .cancel .closeBtn').click(function (){
        $(this).parents('.cancel').children('.alert-modal').removeClass('active')
    })
    $('#Reservations .cancel .cancelExec').click(function (){
        $(this).addClass('disabled')
        $('#Reservations .cancel .closeBtn').addClass('disabled')
    })
});